import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  MapPin,
  Heart,
  Share2,
  ArrowRight,
  Building2,
  Ruler,
  Landmark,
  ShieldCheck,
  Zap,
  Sparkles,
  PhoneCall,
  Search,
} from "lucide-react";
import { motion } from "framer-motion";

const buyProperties = [
  {
    id: "premium-french-rowhouses",
    title: "Premium French-Inspired Rowhouses",
    location: "Soukya Road, Whitefield, Bengaluru",
    status: "EOI Open",
    category: "Rowhouses",
    type: "Rowhouse",
    area: "20 Acres",
    units: "242 Rowhouses",
    price: "₹5.40 Cr onwards",
    highlight: "Near Whitefield",
    image:
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1200&q=85",
    url: "/premium-french-rowhouses",
    mapUrl: "https://maps.app.goo.gl/hc4TMzhPXom1rvBMA",
    description:
      "Ultra-premium French-inspired rowhouses with elegant architecture, Vastu-compliant homes and central courtyards.",
  },
  {
    id: "brigade-granada",
    title: "Brigade Granada",
    location: "Seegahalli Road, East Bengaluru",
    status: "EOI Open",
    category: "Townships",
    type: "Township",
    area: "40+ Acres",
    units: "55-Floor Towers",
    price: "₹1.75 Cr onwards",
    highlight: "Brigade Group",
    image:
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1200&q=85",
    url: "/brigade-granada",
    mapUrl: "https://maps.app.goo.gl/dwWNkRhi43Wo37we6",
    description:
      "A landmark mixed-use township with excellent connectivity to Whitefield, Kadugodi, ITPL and KR Puram.",
  },
  {
    id: "sanjeevini-heliconia",
    title: "Sanjeevini Heliconia",
    location: "Soukya Road, Whitefield, Bengaluru",
    status: "RERA Registered",
    category: "Apartments",
    type: "Residential",
    area: "1175 – 1690 ft²",
    units: "Exclusive Residences",
    price: "₹85 Lakhs onwards",
    highlight: "PRM/KA/RERA Registered",
    image:
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1200&q=85",
    url: "/sanjeevini-heliconia",
    mapUrl: "https://maps.app.goo.gl/U6eeRR7hYbMgZ2gf8",
    description:
      "An exclusive residential landmark combining refined architecture, serenity and convenient access to ITPL and Whitefield.",
  },
  {
    id: "poulomi-florique",
    title: "Poulomi Florique",
    location: "Thanisandra, Bangalore",
    status: "Under Construction",
    category: "Apartments",
    type: "3 & 4 BHK Luxury",
    area: "1,585 – 2,740 ft²",
    units: "8.66 Acres",
    price: "₹1.45 Cr onwards",
    highlight: "IGBC Platinum Pre-certified",
    image:
      "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&w=1200&q=85",
    url: "/poulomi-florique",
    mapUrl: "https://maps.app.goo.gl/SbmK47wMm21go1dM9?g_st=awb",
    description:
      "Premium IGBC Platinum pre-certified community with 40+ amenities, 37,800 sqft clubhouse, and sports zone.",
  },
  {
    id: "sobha-one-world",
    title: "Sobha OneWorld — One Residences",
    location: "Greater Whitefield, Bengaluru",
    status: "New Launch",
    category: "Apartments",
    type: "3 & 4 BHK High-Rise",
    area: "1,100 – 1,542 ft²",
    units: "14 Wings · 3,484 Units",
    price: "₹13,999 / sft",
    highlight: "Sobha Quality",
    image:
      "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?auto=format&fit=crop&w=1200&q=85",
    url: "/sobha-one-world",
    mapUrl: "https://maps.app.goo.gl/kXh47Z6t8B9k4v2K9",
    description:
      "A 48-acre integrated world inside Greater Whitefield with world-class amenities, expansive landscapes, and signature Sobha finishes.",
  },
  {
    id: "prestige-waterford",
    title: "Prestige Waterford",
    location: "ECC Road, Whitefield, Bengaluru",
    status: "Ready Possession",
    category: "Apartments",
    type: "3 & 4 BHK Residences",
    area: "1,800 – 2,950 ft²",
    units: "16 Acres · 689 Units",
    price: "₹2.1 Cr onwards",
    highlight: "Prestige Group",
    image:
      "https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?auto=format&fit=crop&w=1200&q=85",
    url: "/rivera-edition",
    mapUrl: "https://maps.app.goo.gl/SbmK47wMm21go1dM9",
    description:
      "Premium gated enclave right off ECC Road Whitefield offering timeless architecture, lush open parks, and swift metro connectivity.",
  },
  {
    id: "folium-by-sumadhura",
    title: "Folium by Sumadhura",
    location: "Siddapura, Whitefield, Bengaluru",
    status: "New Phase Open",
    category: "Apartments",
    type: "2 & 3 BHK Living",
    area: "1,350 – 1,980 ft²",
    units: "16+ Acres Greens",
    price: "₹1.65 Cr onwards",
    highlight: "Lake-facing Living",
    image:
      "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?auto=format&fit=crop&w=1200&q=85",
    url: "/sumadhura-edition",
    mapUrl: "https://maps.app.goo.gl/dwWNkRhi43Wo37we6",
    description:
      "Nature-inspired community surrounded by lush greenery, private lake views, and quick access to ITPL and IT tech corridors.",
  },
  {
    id: "riviera-north",
    title: "Riviera North Edition",
    location: "Whitefield, Bengaluru",
    status: "Exclusive Phase",
    category: "Rowhouses",
    type: "Luxury Residences",
    area: "1,450 – 2,200 ft²",
    units: "Limited Collection",
    price: "₹1.90 Cr onwards",
    highlight: "Whitefield Hub",
    image:
      "https://images.unsplash.com/photo-1600566753376-12c8ab7fb75b?auto=format&fit=crop&w=1200&q=85",
    url: "/riviera-north-edition",
    mapUrl: "https://maps.app.goo.gl/hc4TMzhPXom1rvBMA",
    description:
      "Refined architectural homes crafted for modern Bengaluru families seeking luxury, privacy, and exceptional connectivity.",
  },
];

const categories = ["All", "Rowhouses", "Townships", "Apartments"];

const Buy = () => {
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");

  const filteredProperties = buyProperties.filter((property) => {
    const matchesCategory =
      selectedCategory === "All" || property.category === selectedCategory;
    const matchesSearch =
      property.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      property.location.toLowerCase().includes(searchQuery.toLowerCase()) ||
      property.type.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  const handleShare = (e, property) => {
    e.preventDefault();
    e.stopPropagation();

    const message = `🏡 *${property.title}*

📍 ${property.location}
💰 Price: ${property.price}
✨ Type: ${property.type}
📐 Area: ${property.area}
🏢 Units: ${property.units}

${property.description}

🔗 View Property:
${window.location.origin}${property.url}

Hi HousyHunt, I'm interested in purchasing this property. Please share details and pricing sheet.`;

    const whatsappUrl = `https://wa.me/918088687429?text=${encodeURIComponent(
      message
    )}`;

    window.open(whatsappUrl, "_blank");
  };

  return (
    <div className="w-full bg-[#FAFCFF] min-h-screen">
      {/* ================= HERO HEADER ================= */}
      <section className="relative overflow-hidden bg-gradient-to-b from-red-50/80 via-white to-[#FAFCFF] pt-12 pb-16 px-4 sm:px-6 lg:px-14 border-b border-gray-100">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col items-center text-center">
            <span className="inline-flex items-center gap-2 bg-red-100/70 text-red-600 border border-red-200/80 px-4 py-2 rounded-full text-xs sm:text-sm font-bold tracking-wide uppercase mb-4 shadow-sm">
              <Sparkles size={15} />
              Buy Properties in Bengaluru
            </span>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-gray-900 tracking-tight leading-[1.15] max-w-4xl">
              Find Your Dream Home,{" "}
              <span className="text-red-600">Verified & Ready to Buy.</span>
            </h1>

            <p className="mt-5 text-gray-600 text-base sm:text-lg max-w-2xl leading-relaxed">
              Explore handpicked villas, rowhouses, and luxury apartments from
              Bengaluru’s leading developers with zero hidden charges and complete
              legal verification.
            </p>

            {/* SEARCH & FILTERS */}
            <div className="mt-8 w-full max-w-2xl flex flex-col sm:flex-row items-center gap-3">
              <div className="relative w-full">
                <Search
                  size={18}
                  className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"
                />
                <input
                  type="text"
                  placeholder="Search by location, project, or property type..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full pl-11 pr-4 py-3.5 rounded-full border border-gray-200 bg-white text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-red-500/20 focus:border-red-500 transition shadow-sm text-sm"
                />
              </div>
            </div>

            {/* CATEGORY PILLS */}
            <div className="mt-6 flex flex-wrap items-center justify-center gap-2 sm:gap-3">
              {categories.map((cat) => (
                <button
                  key={cat}
                  onClick={() => setSelectedCategory(cat)}
                  className={`px-5 py-2.5 rounded-full text-xs sm:text-sm font-semibold transition-all duration-200 ${
                    selectedCategory === cat
                      ? "bg-red-600 text-white shadow-md shadow-red-500/20"
                      : "bg-white text-gray-700 border border-gray-200 hover:border-red-300 hover:text-red-600"
                  }`}
                >
                  {cat}
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ================= PROPERTY CARDS GRID ================= */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-14 py-16">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl sm:text-3xl font-black text-gray-900">
              Available Properties for Sale
            </h2>
            <p className="text-gray-500 text-sm mt-1">
              Showing {filteredProperties.length} verified listings in Bengaluru
            </p>
          </div>

          <a
            href="https://wa.me/message/MDG2ZSZNG6P6G1"
            target="_blank"
            rel="noopener noreferrer"
            className="hidden sm:inline-flex items-center gap-2 text-sm font-bold text-red-600 hover:text-red-700"
          >
            <PhoneCall size={16} /> Need help choosing? Chat with us
          </a>
        </div>

        {filteredProperties.length === 0 ? (
          <div className="text-center py-20 bg-white rounded-3xl border border-gray-100 p-8 shadow-sm">
            <Building2 size={48} className="mx-auto text-gray-300 mb-4" />
            <h3 className="text-lg font-bold text-gray-800">
              No properties matched your criteria
            </h3>
            <p className="text-gray-500 text-sm mt-1">
              Try adjusting your search terms or filters.
            </p>
            <button
              onClick={() => {
                setSelectedCategory("All");
                setSearchQuery("");
              }}
              className="mt-5 px-6 py-2.5 bg-red-600 text-white rounded-full text-sm font-semibold hover:bg-red-700 transition"
            >
              Reset Filters
            </button>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredProperties.map((property) => (
              <motion.div
                key={property.id}
                whileHover={{ y: -6 }}
                transition={{ duration: 0.3 }}
                className="bg-white rounded-3xl overflow-hidden border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-300 flex flex-col group"
              >
                {/* IMAGE CONTAINER */}
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={property.image}
                    alt={property.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />

                  {/* GRADIENT OVERLAY */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-black/20" />

                  {/* TOP BADGES */}
                  <div className="absolute top-4 left-4 right-4 flex items-center justify-between">
                    <span className="bg-red-600/90 backdrop-blur-md text-white text-[11px] font-bold px-3 py-1 rounded-full uppercase tracking-wider shadow">
                      {property.status}
                    </span>

                    <button
                      type="button"
                      onClick={(e) => handleShare(e, property)}
                      aria-label={`Share ${property.title}`}
                      className="w-9 h-9 rounded-full bg-white/90 backdrop-blur-md hover:bg-white text-gray-700 hover:text-black flex items-center justify-center shadow transition-all duration-200 hover:scale-105"
                    >
                      <Share2 size={16} />
                    </button>
                  </div>

                  {/* BOTTOM HIGHLIGHT ON IMAGE */}
                  <div className="absolute bottom-4 left-4 right-4 flex items-end justify-between text-white">
                    <div>
                      <span className="text-[11px] uppercase tracking-widest text-red-200 font-semibold">
                        {property.highlight}
                      </span>
                      <p className="text-xl font-black drop-shadow-sm">
                        {property.price}
                      </p>
                    </div>
                    <span className="text-xs font-semibold bg-black/40 backdrop-blur-md px-3 py-1 rounded-full">
                      {property.type}
                    </span>
                  </div>
                </div>

                {/* CONTENT */}
                <div className="p-6 flex flex-col flex-grow">
                  <h3 className="text-xl font-bold text-gray-900 group-hover:text-red-600 transition-colors line-clamp-1">
                    {property.title}
                  </h3>

                  <div className="flex items-center gap-1.5 text-gray-500 text-xs mt-2">
                    <MapPin size={14} className="text-red-500 shrink-0" />
                    <span className="truncate">{property.location}</span>
                  </div>

                  <p className="text-gray-600 text-xs mt-3 line-clamp-2 leading-relaxed">
                    {property.description}
                  </p>

                  {/* PROPERTY HIGHLIGHTS GRID */}
                  <div className="grid grid-cols-2 gap-2 mt-5 p-3 rounded-2xl bg-gray-50 border border-gray-100 text-xs text-gray-700">
                    <div className="flex items-center gap-2">
                      <Ruler size={14} className="text-red-600" />
                      <span className="font-semibold truncate">
                        {property.area}
                      </span>
                    </div>
                    <div className="flex items-center gap-2">
                      <Building2 size={14} className="text-red-600" />
                      <span className="font-semibold truncate">
                        {property.units}
                      </span>
                    </div>
                  </div>

                  {/* ACTION BUTTONS */}
                  <div className="mt-6 pt-4 border-t border-gray-100 flex items-center gap-3">
                    <Link
                      to={property.url}
                      className="flex-1 py-3 px-4 bg-gray-900 hover:bg-red-600 text-white rounded-xl font-semibold text-xs transition-colors duration-300 flex items-center justify-center gap-1.5 group/btn"
                    >
                      <span>Explore</span>
                      <ArrowRight
                        size={14}
                        className="group-hover/btn:translate-x-1 transition-transform"
                      />
                    </Link>

                    <button
                      type="button"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        window.open(
                          "https://wa.me/message/MDG2ZSZNG6P6G1",
                          "_blank",
                          "noopener,noreferrer"
                        );
                      }}
                      className="py-3 px-5 bg-red-600 hover:bg-red-700 text-white rounded-xl font-semibold text-xs transition-colors shadow-md hover:shadow-red-500/20"
                    >
                      Contact
                    </button>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        )}
      </section>

      {/* ================= TRUST BADGES ================= */}
      <section className="bg-white py-16 px-4 sm:px-6 lg:px-14 border-t border-gray-100">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="flex items-start gap-4">
              <div className="p-3 bg-red-50 rounded-2xl text-red-600 shrink-0">
                <ShieldCheck size={24} />
              </div>
              <div>
                <h4 className="font-bold text-gray-900 text-base">
                  100% Verified Titles
                </h4>
                <p className="text-xs text-gray-500 mt-1 leading-relaxed">
                  Every property undergoes strict legal and RERA scrutiny before
                  listing.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="p-3 bg-red-50 rounded-2xl text-red-600 shrink-0">
                <Zap size={24} />
              </div>
              <div>
                <h4 className="font-bold text-gray-900 text-base">
                  Direct Builder Pricing
                </h4>
                <p className="text-xs text-gray-500 mt-1 leading-relaxed">
                  Zero hidden broker fees on verified builder launches and EOIs.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="p-3 bg-red-50 rounded-2xl text-red-600 shrink-0">
                <Landmark size={24} />
              </div>
              <div>
                <h4 className="font-bold text-gray-900 text-base">
                  Home Loan Support
                </h4>
                <p className="text-xs text-gray-500 mt-1 leading-relaxed">
                  Seamless loan sanctions with India's leading banks at lowest
                  rates.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="p-3 bg-red-50 rounded-2xl text-red-600 shrink-0">
                <Building2 size={24} />
              </div>
              <div>
                <h4 className="font-bold text-gray-900 text-base">
                  Site Visit Concierge
                </h4>
                <p className="text-xs text-gray-500 mt-1 leading-relaxed">
                  Free private chauffeur pickups for qualified project inspections.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Buy;
